<template>
  <div
    class="dragger dragger-margin"
    :class="isMarker ? 'marker' : 'slider'"
    :style="{ left: `${positionX}px` }"
    @mousedown="handleMouseDown"
  >
    <slot />
  </div>
</template>

<script>
export default {
  name: "ClipDragger",
  props: {
    positionX: {
      type: Number,
      default: 0,
    },
    isMarker: {
      type: Boolean,
    },
  },
  emits: ["on-drag"],
  data() {
    return {
      screenX: null,
      orientationX: null,
    };
  },
  methods: {
    handleMouseDown(event) {
      this.screenX = event.screenX;
      this.orientationX = this.positionX;

      window.addEventListener("mousemove", this.handleMouseMove, false);
      window.addEventListener("mouseup", this.handleMouseUp, false);
    },
    handleMouseMove(event) {
      this.$emit("on-drag", {
        x: event.screenX - this.screenX + this.orientationX,
      });
    },
    handleMouseUp() {
      window.removeEventListener("mousemove", this.handleMouseMove);
      window.removeEventListener("mouseup", this.handleMouseUp);
    },
  },
};
</script>

<style lang="scss" scoped>
.dragger {
  position: absolute;
  top: 0;
  bottom: 0;
  cursor: col-resize;

  &.slider {
    width: 5px;
    z-index: 1;
    background: $priority-medium;
  }

  &.marker {
    width: 2px;
    z-index: 2;
    background: $white;
    transition: all 0.2s ease-in-out;
  }
}

.dragger-margin {
  margin-top: 30px;
  margin-bottom: 30px;
}

.dragger-line {
  position: absolute;
  border-left: 1px solid black;
  height: 15px;
  left: 40%;
  top: 13px;
}
</style>
